export const PerformanceCategory = {
    Solo: "Solo",
    Ensemble: "Ensemble"
}

export const VocalGenreCategory = {
    Classical: "Classical",
    FreeGenre: "FreeGenre"
}

export const ageCategories = {
    Poco: "Poco (4-5 years old)",
    Petite: "Petite (6-7 years old)",
    Primary: "Primary (8-11 years old)",
    Young: "Young (12-15 years old)",
    Junior: "Junior (16-19 years old)",
    Youth: "Youth (20-23 years old)",
    OpenAge: "Open Age (24+ years old)",
    JuniorEtude: "Junior Etude (4+ years old)",
    ConcertEtude: "Concert Etude (4+ years old)",
    FreeChoice: "Free Choice (4+ years old)",
    YoungArtists: "Young Artists (4+ years old)",
}

export const ensembleAgeCategories = {
    older_than_four: "4+* years old (Combination Age)",
}

export const stringAgeCategoriesSolo = {
    PocoStrings: "Poco (4-5 years old)",
    PetiteStrings: "Petite (6-7 years old)",
    PrimaryStrings: "Primary (8-11 years old)",
    YoungStrings: "Young (12-15 years old)",
    JuniorStrings: "Junior (16-19 years old)",
    YouthStrings: "Youth (20-23 years old)",
    OpenAgeStrings: "Open Age (24+ years old)",
    FreeChoiceStrings: "Free Choice (4+ years old)",
    YoungArtistStrings: "Young Artist (4+ years old)",
}


export const vocalAgeCategoriesSolo = {
    PetiteVocal: "Petite (4-6 years old)",
    PrimaryVocal: "Primary (7-9 years old)",
    YoungVocal: "Young (10-12 years old)",
    JuniorVocal: "Junior (13-15 years old)",
    YouthVocal: "Youth (16-19 years old)",
    OpenAgeVocal: "Open Age (9+ years old)",
    ProfessionalVocal: "Professionals (19+ years old)",
    FreeChoiceVocal: "Free Choice (4+ years old)",
}


export const woodwinAgeCategoriesSolo = {
    PocowoodWind: "Poco (4-5 years old)",
    PetitewoodWind: "Petite (6-7 years old)",
    PrimarywoodWind: "Primary (8-11 years old)",
    YoungwoodWind: "Young (12-15 years old)",
    JuniorwoodWind: "Junior (16-19 years old)",
    YouthwoodWind: "Youth (20-23 years old)",
    OpenAgewoodWind: "Open Age (24+ years old)",
    FreeChoicewoodWind: "Free Choice (4+ years old)",
    YoungArtistwoodWind: "Young Artist (4+ years old)",
}


export const percussionAgeCategoriesSolo = {
    PocoPercussion: "Poco (4-5 years old)",
    PetitePercussion: "Petite (6-7 years old)",
    PrimaryPercussion: "Primary (8-11 years old)",
    YoungPercussion: "Young (12-15 years old)",
    JuniorPercussion: "Junior (16-19 years old)",
    YouthPercussion: "Youth (20-23 years old)",
    OpenAgePercussion: "Open Age (24+ years old)",
    FreeChoicePercussion: "Free Choice (4+ years old)",
    YoungArtistPercussion: "Young Artist (4+ years old)",
}


export const guitarAgeCategoriesSolo = {
    PocoGuitar: "Poco (4-5 years old)",
    PetiteGuitar: "Petite (6-7 years old)",
    PrimaryGuitar: "Primary (8-11 years old)",
    YoungGuitar: "Young (12-15 years old)",
    JuniorGuitar: "Junior (16-19 years old)",
    YouthGuitar: "Youth (20-23 years old)",
    OpenAgeGuitar: "Open Age (24+ years old)",
    FreeChoiceGuitar: "Free Choice (4+ years old)",
    YoungArtistGuitar: "Young Artist (4+ years old)",
}


export const brassAgeCategoriesSolo = {
    PocoBrass: "Poco (4-5 years old)",
    PetiteBrass: "Petite (6-7 years old)",
    PrimaryBrass: "Primary (8-11 years old)",
    YoungBrass: "Young (12-15 years old)",
    JuniorBrass: "Junior (16-19 years old)",
    YouthBrass: "Youth (20-23 years old)",
    OpenAgeBrass: "Open Age (24+ years old)",
    FreeChoiceBrass: "Free Choice (4+ years old)",
    YoungArtistBrass: "Young Artist (4+ years old)",
}


export const electoneAgeCategoriesSolo = {
    PocoElectone: "Poco (4-5 years old)",
    PetiteElectone: "Petite (6-7 years old)",
    PrimaryElectone: "Primary (8-11 years old)",
    YoungElectone: "Young (12-15 years old)",
    JuniorElectone: "Junior (16-19 years old)",
    YouthElectone: "Youth (20-23 years old)",
    OpenAgeElectone: "Open Age (24+ years old)",
    FreeChoiceElectone: "Free Choice (4+ years old)",
    YoungArtistElectone: "Young Artist (4+ years old)",
    JuniorEtudeElectone: "Junior Etude (4+ years old)",
}

export const harpAgeCategoriesSolo = {
    PetiteHarp: "Petite (4-6 years old)",
    PrimaryHarp: "Primary (7-9 years old)",
    YoungHarp: "Young (10-12 years old)",
    JuniorHarp: "Junior (13-15 years old)",
    YouthHarp: "Youth (16-19 years old)",
    OpenAgeHarp: "Open Age (20-23 years old)",
    ProfessionalsHarp: "Professionals (24+ years old)",
    FreeChoiceHarp: "Free Choice (4+ years old)",
    YoungArtistHarp: "Young Artist (4+ years old)",
}


export const guzhengAgeCategoriesSolo = {
    PetiteGuzheng: "Petite (4-6 years old)",
    PrimaryGuzheng: "Primary (7-12 years old)",
    YouthGuzheng: "Youth (13-18 years old)",
    OpenAgeGuzheng: "Open Age (19+ years old)",
    ProfessionalsGuzheng: "Professionals (19+ years old)",
    FreeChoiceGuzheng: "Free Choice (4+ years old)",
}

export const guzhengAgeCategoriesEnsemble = {
    four_plus_guzheng: "4+ years old",
}


export const competitionList = {
    Piano: "Piano",
    Woodwinds: "Woodwinds",
    Percussions: "Percussions",
    Strings: "Strings",
    Brass: "Brass",
    Guitar: "Guitar",
    VocalChoir: "VocalChoir",
    Harp: "Harp",
    Guzheng: "Guzheng",
    Electone: "Electone",
}

export const ElectoneInstrumentListSolo = {
    Electone_Solo: "Electone Solo",
}

export const PianoInstrumentList = {
    Piano_Solo: "Piano Solo (One piano, two hands)",
    Piano_Fourhands_one: "Piano Fourhands (One piano, four hands)",
    Piano_Fourhands_two: "Piano Fourhands (Two pianos, four hands)",
    Chamber_Music_one: "Chamber Music (One piano, six-eight hands)",
    Chamber_Music_two: "Chamber Music (Two pianos, six-eight hands)",
    Chamber_Music_any: "Chamber Music (Any instrument(s) with piano(s))",
}

export const PianoInstrumentListSolo = {
    Piano_Solo: "Piano Solo (One piano, two hands)",
}

export const InstrumentListEnsembleNew = {
    Professionals_any_genre: "Professionals A (Any Genre)",
    Non_Professionals_any_genre: "Non_Professionals A (Any Genre)",
    Professionals_Own_Arrangement: "Professionals B (Own Arrangement/Composition)",
    Non_Professionals_Own_Arrangement: "Non_Professionals B (Own Arrangement/Composition)"
}

export const StringsInstrumentListSolo = {
    Strings_Solo: "Strings Solo",
}

export const VocalInstrumentListSolo = {
    SoloVocal: "Solo With Acoustic Instrument (Classical)",
    SoloAcousticVocal: "Solo Without Acoustic Instrument (Free Genre)"
}

export const VocalChoirInstrumentEnsembleClassical = {
    Professionals_A: "Professionals A (19+ years old)",
    Non_Professionals_A: "Non-Professional A (4+ years old)"
}

export const VocalChoirInstrumentEnsembleFreeGenre = {
    Professionals_B: "Professionals B (19+ years old)",
    Non_Professionals_B: "Non-Professional B (4+ years old)",
    Professionals_C: "Professionals C (19+ years old)",
    Non_Professionals_C: "Non-Professional C (4+ years old)"
}

export const PercussionInstrumentListSolo = {
    Marimba: "Marimba",
    Vibraphone: "Vibraphone",
    Multi_percussion: "Multi Percussion",
    Any_Traditional_Percussion: "Any Traditional Percussion",
}

export const GuitarInstrumentListSolo = {
    Classic: "Classical Nylon Guitar (Classical)",
    FreeGenre: "Any Acoustic Guitar Strings and Nylon (Free Genre)*",
    Any_Traditional_Guitar: "Any Traditional Guitar",
}

export const HarpInstrumentListSolo = {
    pedal: "Pedal Harp",
    lever: "Lever Harp",
    Any_Traditional_Harp: "Any Traditional Harp",
}

export const BrassInstrumentListSolo = {
    trumpet: "Trumpet",
    trombone: "Trombone",
    french_horn: "French Horn",
    tuba: "Tuba",
    any_traditional: "Any Traditional Brass",
}

export const WoodwindInstrumentListSolo = {
    Piccolo: "Piccolo",
    Flute: "Flute",
    Oboe: "Oboe",
    Clarinet: "Clarinet",
    Saxophone: "Saxophone",
    Bassoon: "Bassoon",
    any_traditional_woodwind: "Any Traditional Woodwind",
}

export const GuzhengInstrumentListSolo = {
    one_guzheng: "1 Guzheng"
}

export const GuzhengInstrumentListEnsemble = {
    ChineseMusicEnsemble: "Chinese Music Ensemble (Guzheng combined with other instruments)",
    GuzhengEnsemble: "Guzheng Ensemble (Guzheng only)"
}